<div class="  ">
  <h2 class="sectionTitle">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.TITLE' | translate }}</h2>


  <div *ngFor="let supplierEvaluation of TenderSuppliersEvaluationLst; let i = index;">
    <div class="full-card">
      <div class="card-header">
        <div [ngSwitch]="supplierEvaluation.IsHighPrice">
          <label id="rating'{{i}}'" *ngSwitchCase="null" class="rating-label no-rate"></label>
          <label id="rating'{{i}}'" *ngSwitchCase="true"
            class="rating-label high-rate">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.HIGH' | translate }}</label>
          <label id="rating'{{i}}'" *ngSwitchCase="false"
            class="rating-label low-rate">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.LOW' | translate }}</label>
        </div>
        <div class="form-container">
          <div class="form-group">
            <div class="custom-checkbox">
              <input type="checkbox" id="supplierName'{{i}}'"  name="supplierName'{{i}}'"
                [(ngModel)]="supplierEvaluation.IsWinner" value="true"/>
               <label for="supplierName'{{i}}'"  data-toggle="tooltip"
              title="{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.WINNER' | translate}}">{{supplierEvaluation.Supplier.CompanyName}}
                {{supplierEvaluation.Supplier.SupplierNumber}}</label>
            </div>
          </div>

        </div>
      </div>
      <div class="in" id="{{i}}">
        <div class="card-body">
          <div class="form-container">
            <div class="form-group">
              <label>{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.INVOLVING' | translate }}</label>
              <div class="form-custom-inputs">
                <div class="custom-Radio">
                  <input type="radio" id="Involved'{{i}}'"  name="IsSupplierInvolved'{{i}}'"
                    [(ngModel)]="supplierEvaluation.IsSupplierInvolved" [value]="true" />
                  <label
                    for="Involved'{{i}}'">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.INVOLVED' | translate }}</label>
                </div>
                <div class="custom-Radio">
                  <input type="radio" id="NotInvolved'{{i}}'"  name="IsSupplierInvolved'{{i}}'"
                    [(ngModel)]="supplierEvaluation.IsSupplierInvolved"  [value]="false" />
                  <label
                    for="NotInvolved'{{i}}'">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.NOTINVOLOVED' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="form-group" *ngIf="supplierEvaluation.IsSupplierInvolved">
              <label>{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.QUALIFIEDEVALUATION' | translate }}</label>
              <div class="form-custom-inputs">
                <div class="custom-Radio">
                  <input type="radio" id="Qualified'{{i}}'"  name="IsQualified'{{i}}'"
                    [(ngModel)]="supplierEvaluation.IsQualified"  [value]="true" />
                  <label
                    for="Qualified'{{i}}'">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.QUALIFIED' | translate }}</label>
                </div>
                <div class="custom-Radio">
                  <input type="radio" id="NotQualified'{{i}}'"  name="IsQualified'{{i}}'"
                    [(ngModel)]="supplierEvaluation.IsQualified"  [value]="false" />
                  <label
                    for="NotQualified'{{i}}'">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.NOTQUALIFIED' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="form-group" *ngIf="supplierEvaluation.IsSupplierInvolved">
              <label>{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.PRICE' | translate }}</label>
              <div class="form-custom-inputs">
                <div class="custom-Radio">
                  <input type="radio" id="HighPrice'{{i}}'"  name="IsHighPrice'{{i}}'"
                    [(ngModel)]="supplierEvaluation.IsHighPrice"  [value]="true" />
                  <label for="HighPrice'{{i}}'">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.HIGH' | translate }}</label>
                </div>
                <div class="custom-Radio">
                  <input type="radio" id="LowPrice'{{i}}'"  name="IsHighPrice'{{i}}'"
                    [(ngModel)]="supplierEvaluation.IsHighPrice"  [value]="false" />
                  <label for="LowPrice'{{i}}'">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.LOW' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="form-group"
              *ngIf="supplierEvaluation.IsSupplierInvolved && supplierEvaluation.ETender.HaveAlternativeOffers">
              <label>{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.ISMORETHANONEOFFER' | translate }}</label>
              <div class="form-custom-inputs">
                <div class="custom-Radio">
                  <input type="radio" id="MORETHANONEOFFER'{{i}}'"  name="ISMORETHANONEOFFER'{{i}}'"
                    [(ngModel)]="supplierEvaluation.IsMoreThanOneOffer"  [value]="true" />
                  <label
                    for="MORETHANONEOFFER'{{i}}'">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.MORETHANONEOFFER' | translate }}</label>
                </div>
                <div class="custom-Radio">
                  <input type="radio" id="LESSTHANONEOFFER'{{i}}'"  name="ISMORETHANONEOFFER'{{i}}'"
                    [(ngModel)]="supplierEvaluation.IsMoreThanOneOffer"  [value]="false" />
                  <label
                    for="LESSTHANONEOFFER'{{i}}'">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.LESSTHANONEOFFER' | translate }}</label>
                </div>
              </div>
            </div>

            <div class="form-group" *ngIf="supplierEvaluation.IsSupplierInvolved">
              <label>{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.TECHNICALCOMMENTS' | translate }}</label>
              <textarea id="QualificationComment'{{i}}'"  name="QualificationComment" class="form-control"
                [(ngModel)]="supplierEvaluation.QualificationComment"></textarea>
            </div>
            <div class="form-group" *ngIf="supplierEvaluation.IsSupplierInvolved">
              <label>{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.FINANCIALCOMMENTS' | translate }}</label>
              <textarea id="PricingComment'{{i}}'"  name="PricingComment" class="form-control"
                [(ngModel)]="supplierEvaluation.PricingComment"></textarea>
            </div>
          </div>

          <p class="btns-holder">
            <button class="btn SCAcustomBtn inverse-btn" type="button" Confirmation
              (confirmationClick)="evaluateTender(supplierEvaluation)">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.SAVE' | translate }}</button>
          </p>

        </div>
      </div>

      <div class="btn-holder full-width">
        <button class="btn SCAcustomBtn" type="button" data-toggle="collapse" [attr.data-target]="'#' + i"
          aria-expanded="false"
          aria-controls="i">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.EVALUATION' | translate }}</button>
      </div>
    </div>

  </div>

  <!-- <div id="winner" *ngIf="TenderSuppliersEvaluationLst.length>0">
    <button class="btn SCAcustomBtn" type="button" Confirmation (confirmationClick)="setTenderWinner()">{{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.WINNER' | translate }}</button>
  </div> -->

</div>